export const styles = {
  conatainer: {
    marginTop: 80,
    marginBottom: 80
  },
  padding: {
    padding: 40
  },
  section: {
    fontFamily: '"Nunito", sans-serif',
    color: '#2F3755',
    textAlign: 'center',
    '& > h3': {
      fontWeight: 700,
      fontSize: 18
    },
    '& > p': {
      fontWeight: 400,
      fontSize: 18,
      lineHeight: '24px'
    }

  }
}



// WEBPACK FOOTER //
// ./src/layouts/Styles/FeatureSection.Style.js